import React, { FC } from 'react';
import { Notification } from '../../../common/model/dto/notification/notification';
import StringUtils from '../../../common/utils/services/string-utils';
import OvNotificationsTypeaheadListItem from '../atoms/OvNotificationsTypeaheadListItem';
import OvSearchTypeahead from './OvSearchTypeahead';

interface OvNotificationTypeaheadProps {
  placeholder?: string;
  onNotificationSelect?: (notification: Notification | null) => void;
  fetchNotifications: (
    searchText: string
  ) => Promise<Notification[]> | undefined;
  className?: string;
}

const OPTION_LABEL_LENGTH = 20;
const LIST_ITEM_TITLE_LENGTH = 29;

const OvNotificationTypeahead: FC<OvNotificationTypeaheadProps> = ({
  placeholder,
  onNotificationSelect,
  fetchNotifications,
  className,
}) => (
  <OvSearchTypeahead<Notification>
    searchKey="notifications"
    fetchOptions={fetchNotifications}
    getOptionLabel={({ notification_content }) =>
      notification_content.title
        ? StringUtils.truncateString(
            notification_content.title,
            OPTION_LABEL_LENGTH
          )
        : ''
    }
    onSelect={onNotificationSelect}
    placeholder={placeholder}
    className={className}
    renderOption={(props, { notification_content, user }) => (
      <OvNotificationsTypeaheadListItem
        {...props}
        items={[
          {
            notificationContentTitle: StringUtils.truncateString(
              notification_content.title,
              LIST_ITEM_TITLE_LENGTH
            ),
            notificationContentCategory: notification_content.category,
            email: user.email,
          },
        ]}
      />
    )}
  />
);

export default OvNotificationTypeahead;
